const devProxyApiBase = '/api';
const directLocalApiBase = 'http://localhost:5002/api';

const envApiBase =
  process.env.REACT_APP_API_HOST ||
  process.env.REACT_APP_API_URL ||
  '';

const isBrowser = typeof window !== 'undefined';
const isLocalhostHost = isBrowser && ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
const isDevelopment = process.env.NODE_ENV === 'development';
const sameOriginApiBase = isBrowser ? `${window.location.origin}/api` : '/api';

// In local development, always prefer the local backend so admin auth requests do
// not accidentally target the hosted production API. Set REACT_APP_USE_DEV_PROXY=true
// if you explicitly want to rely on the CRA proxy instead of the direct backend URL.
const useDevProxy = process.env.REACT_APP_USE_DEV_PROXY === 'true';
const rawApiBase = isDevelopment && isLocalhostHost
  ? (useDevProxy ? devProxyApiBase : directLocalApiBase)
  : (envApiBase || sameOriginApiBase);

export const API_BASE_URL = rawApiBase.replace(/\/+$/, '');

export const BACKEND_BASE_URL = API_BASE_URL.endsWith('/api')
  ? API_BASE_URL.slice(0, -4)
  : API_BASE_URL;
